
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
::host{
  display:block;
}

.social-share-button__link, .social-share-button__icon {
  display:inline-block;
}

.social-share-button__link {
  text-decoration-line:none;
}

.social-share__group {
  display:flex;
  flex-wrap:wrap;
  gap:1.25rem;
}

@media (min-width: 768px) {

  .social-share__group {
    justify-content:flex-start;
  }
}

.social-share__group--left {
  justify-content:flex-start;
}

.social-share__group--center {
  justify-content:center;
}

.social-share__group--right {
  justify-content:flex-end;
}

.social-share__group--boxes .social-share-button {
  box-sizing:border-box;
  display:flex;
  height:2.25rem;
  width:2.25rem;
  align-items:center;
  justify-content:center;
  border-radius:0.125rem;

  transform:translate(0);
  transition:opacity 0.2s ease-in, transform 0.2s ease-in;
  -webkit-transition:opacity 0.2s ease-in, transform 0.2s ease-in;
  -o-transition:opacity 0.2s ease-in, transform 0.2s ease-in;
  -ms-transition:opacity 0.2s ease-in, transform 0.2s ease-in;
  -moz-transition:opacity 0.2s ease-in, transform 0.2s ease-in;
}

.social-share__group--boxes .social-share-button i{
    margin-top:30%;
  }

.social-share__group--boxes .social-share-button:hover {
  opacity:0.8;
}

.social-share__group--boxes .social-share-button:hover{

    transform:translate(0, -5px);
  }

.social-share__group--boxes .social-share-button__link {
  margin:0.25rem;
}

.social-share__group--boxes .social-share-button__facebook {
  background-color:var(--social-facebook);
}

.social-share__group--boxes .social-share-button__twitter {
  background-color:var(--social-twitter);
}

.social-share__group--boxes .social-share-button__linkedin {
  background-color:var(--social-linkedin);
}

.social-share__group--boxes .social-share-button__googleplus {
  background-color:var(--social-googleplus);
}

.social-share__group--boxes .social-share-button__email {
  background-color:var(--social-email);
}

.social-share__group--boxes .social-share-button__youtube {
  background-color:var(--social-youtube);
}

.social-share__group--boxes .social-share-button__instagram {
  background-color:var(--social-instagram);
}

.social-share__group--boxes .social-share-button__tiktok {
  background-color:var(--social-tiktok);
}

.social-share__group--with-border .social-share-button__link {
  display:flex;
}

.social-share__group--with-border .social-share-button__link {
  height:3rem;
}

.social-share__group--with-border .social-share-button__link {
  width:3rem;
}

.social-share__group--with-border .social-share-button__link {
  align-items:center;
}

.social-share__group--with-border .social-share-button__link {
  justify-content:center;
}

.social-share__group--with-border .social-share-button__link {
  border-radius:9999px;
}

.social-share__group--with-border .social-share-button__link {
  border-width:1px;
}

.social-share__group--with-border .social-share-button__link {
  border-style:solid;
}

:host([site='GHS']) .social-share__group--boxes .social-share-button__link {
  color:var(--neutral-white);
}

:host([site='GHS']) .social-share-button__link {
  color:var(--neutral-black);
}

:host([site='GHS']) .social-share-button__link:hover{
        color:#007697;
      }

:host([site='GHS']) .social-share__group--light .social-share-button__link{
      color:#f2f2f2;
    }

:host([site='GHS']) .social-share__group--light .social-share-button__link:hover{
        color:#99c8d5;
      }

:host([site='GHS']) .social-share__group--dark .social-share-button__link {
  color:var(--primary-blue-light-2);
}

:host([site='BH']) .social-share__group--boxes .social-share-button__link {
  color:var(--bh-neutral-white);
}

:host([site='BH']) .social-share-button__link {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .social-share-button__link:hover {
  color:var(--bh-brand-primary-dark);
}

:host([site='BH']) .social-share__group--light .social-share-button__link {
  color:var(--bh-neutral-white);
}

:host([site='BH']) .social-share__group--light .social-share-button__link:hover {
  color:var(--bh-brand-primary-lighter);
}

:host([site='BH']) .social-share__group--dark .social-share-button__link {
  color:var(--bh-brand-primary-default);
}
`;